import { Component, OnInit } from '@angular/core';
import { AngularFireDatabase, AngularFireList } from 'angularfire2/database';
import * as Chartist from 'chartist';
import { Observable } from 'rxjs/Observable';
import { Angular2Csv } from 'angular2-csv/Angular2-csv';
declare var $:any;

@Component({
    selector: 'user-cmp',
    moduleId: module.id,
    templateUrl: 'user.component.html'
})

export class UserComponent implements OnInit{
   
    usersRef : AngularFireList<any>;
    folder: AngularFireList<any>;
    usersfire: Observable<any[]>;
  //  img : Observable<any[]>;
  //  images = [];

    //pictures
    users= [];
    userLength;


   // errorCounter = 0;


    //loader 
    // picturesLoader =true;
    // Loader =true;


    constructor(public db : AngularFireDatabase){
        this.usersRef = db.list('users');
        this.usersfire = this.usersRef.snapshotChanges();
        this.usersfire.subscribe(users =>{
            this.users = [];
            this.userLength = users.length;
            console.log(users.length);
    
            for(var i=0; i < users.length ; i ++){
                console.log(users[i])
                 const   user = users[i].payload.val();
                 console.log(user);
                this.users.push({
                    key : users[i].key,
                    email: user.email,
                    mailed: user.mailed,
                    name: user.name ,
                    optIn:  user.optIn,
                    url: user.url

                })
               
              //  this.usersLoader =false;
            }
            console.log(this.users);
            this.users.reverse();
            });
            /**folders.forEach(folder=>{
                console.log(folder);
                console.log(folder.key);
                console.log(folder.val());
                this.folders.push({
                    name: folder.key
                })
                console.log(this.folders);*/
          
        }
        /***/

    ngOnInit(){
    }

    generateCsv(){
        new Angular2Csv(this.users,"scenekings_userList");
        $.notify({
            icon: "ti-check",
            message: "User List <b>Successfully</b> exported."
        },{
            type:  'success',
            timer: 4000,
            placement: {
                from: 'top',
                align: 'right'
            }
        });

    }
    remove(key){
        console.log(key+" removed");
       this.usersRef.remove(key);
        
    }
}



// WEBPACK FOOTER //
// /Users/makebetter/Documents/sportsceneDash/src/app/user/user.component.ts